/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaCanUseResponse model module.
 * @module model/AqaCanUseResponse
 * @version v0
 */
export default class AqaCanUseResponse {
  /**
   * Constructs a new <code>AqaCanUseResponse</code>.
   * @alias module:model/AqaCanUseResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaCanUseResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaCanUseResponse} obj Optional instance to populate.
   * @return {module:model/AqaCanUseResponse} The populated <code>AqaCanUseResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaCanUseResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('canUse'))
        obj.canUse = ApiClient.convertToType(data['canUse'], 'Boolean');
      if (data.hasOwnProperty('freePlanDuration'))
        obj.freePlanDuration = ApiClient.convertToType(data['freePlanDuration'], 'Number');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'Number');
      if (data.hasOwnProperty('left'))
        obj.left = ApiClient.convertToType(data['left'], 'Number');
      if (data.hasOwnProperty('numberOfPurchasedUsers'))
        obj.numberOfPurchasedUsers = ApiClient.convertToType(data['numberOfPurchasedUsers'], 'Number');
      if (data.hasOwnProperty('numberOfDefinedUsers'))
        obj.numberOfDefinedUsers = ApiClient.convertToType(data['numberOfDefinedUsers'], 'Number');
      if (data.hasOwnProperty('planId'))
        obj.planId = ApiClient.convertToType(data['planId'], 'String');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'Number');
      if (data.hasOwnProperty('subscriptionCancelationDate'))
        obj.subscriptionCancelationDate = ApiClient.convertToType(data['subscriptionCancelationDate'], 'Number');
      if (data.hasOwnProperty('canAddUser'))
        obj.canAddUser = ApiClient.convertToType(data['canAddUser'], 'Boolean');
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaCanUseResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaCanUseResponse.prototype.message = undefined;

/**
 * @member {Boolean} canUse
 */
AqaCanUseResponse.prototype.canUse = undefined;

/**
 * @member {Number} freePlanDuration
 */
AqaCanUseResponse.prototype.freePlanDuration = undefined;

/**
 * @member {Number} created
 */
AqaCanUseResponse.prototype.created = undefined;

/**
 * @member {Number} left
 */
AqaCanUseResponse.prototype.left = undefined;

/**
 * @member {Number} numberOfPurchasedUsers
 */
AqaCanUseResponse.prototype.numberOfPurchasedUsers = undefined;

/**
 * @member {Number} numberOfDefinedUsers
 */
AqaCanUseResponse.prototype.numberOfDefinedUsers = undefined;

/**
 * @member {String} planId
 */
AqaCanUseResponse.prototype.planId = undefined;

/**
 * @member {Number} status
 */
AqaCanUseResponse.prototype.status = undefined;

/**
 * @member {Number} subscriptionCancelationDate
 */
AqaCanUseResponse.prototype.subscriptionCancelationDate = undefined;

/**
 * @member {Boolean} canAddUser
 */
AqaCanUseResponse.prototype.canAddUser = undefined;

/**
 * @member {Boolean} successful
 */
AqaCanUseResponse.prototype.successful = undefined;

